module.exports = __webpack_public_path__ + "img/support.bd106856.png";